import { render, staticRenderFns } from "./SidebarItemGroupComponent.vue?vue&type=template&id=e26d875c&scoped=true&"
import script from "./SidebarItemGroupComponent.vue?vue&type=script&lang=js&"
export * from "./SidebarItemGroupComponent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItemGroupComponent.vue?vue&type=style&index=0&id=e26d875c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26d875c",
  null
  
)

export default component.exports